__turbopack_context__.v({
  "loader": "ultrasignal-client-module__Mn_Sua__loader",
});
